export const getNotificationActionPath = (notification) => notification?.metadata?.action_path || '';

export const isTipNotification = (notification) => {
  const type = notification?.notification_type || '';
  return ['post_stay_tip_prompt', 'post_stay_tip_last_chance', 'post_stay_tip_received'].includes(type);
};